import React from 'react';
import clsx from 'clsx';

export function Header({ className, children, ...props }) {
  return (
    <header
      {...props}
      className={clsx(className, 'sm:flex sm:items-start sm:justify-between space-y-4 sm:space-y-0 gap-12')}
    >
    {children}
    </header>
  )
}

export function Heading({ className, level = 1, ...props }) {
  let Element = `h${level}`;
  
  return (
    <Element
      {...props}
      className={clsx(className, 'text-pretty max-w-2xl')}
    />
  )
}

export function Subheading({ className, level = 3, ...props }) {
  let Element = `h${level}`
  return (
    <Element
      {...props}
      className={clsx(className)}
    />
  )
}